import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import { postUploadDocument } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import swal from "sweetalert";
import api from "../dependencies/utils/Api";
import { COHORT_ADD_RESOURCES } from "../constants/ApplicationUrl";
function ModalDocUpload(props) {
  const { mentorshipId, uploadDocumentData, postUploadDocument, cohortId } =
    props;
  const [docTitle, setDocTitle] = useState("");
  const [fileData, setFileData] = useState();
  const [errorVisible, SetErrorVisible] = useState(false);

  //   const hoursData = ["0.5 hr","1 hr","1.5 hr","2 hrs","2.5 hrs","3 hrs","3.5 hrs","4 hrs","4.5 hrs","5 hrs"]
  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const handleInputChange = (e) => {
    // if (e.target.files[0].type == "application/pdf") {
    const fileSize = e.target.files[0].size / 1024 / 1024; // in MB
    if (fileSize > 10) {
      swal({
        title: "Info",
        text: "Uploaded File Exceeded the Size Limit",
        icon: "info",
      });
    } else {
      setFileData((user) => {
        return { ...user, [e.target.name]: e.target.files[0] };
      });
      const newFormData = {
        ...fileData,
        [e.target.name]: e.target.files[0],
      };
      // setAppliedFormData(newFormData);
      // }

      // addDraftData(newFormData, "nextdraftbutton");
    }
  };
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const handleSubmit = () => {
    if (
      cohortId !== undefined &&
      cohortId !== null &&
      cohortId !== "" &&
      docTitle !== "" &&
      fileData !== undefined
    ) {
      handleCohortResources();
    } else if (docTitle !== "" && fileData !== undefined) {
      SetErrorVisible(false);

      const formData = new FormData();
      let params = {
        userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        mentorshipId: mentorshipId,
        documentTitle: docTitle,
      };
      formData.append("application", JSON.stringify(params));
      formData.append("document", fileData?.uploadResume);
      postUploadDocument(formData);
      setTimeout(() => {
        swal({
          title: "Thank You",
          text: `Document Submitted Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        }).then(function () {
          props.sendToParent(true);
          props.setModalVisibility(false);
        });
      }, 500);
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    } else {
      SetErrorVisible(true);
    }
  };
  const handleCohortResources = () => {
    const formData = new FormData();
    formData.append(
      "postData",
      JSON.stringify({ cohortId: cohortId, title: docTitle })
    );
    formData.append("resourceAttach", fileData?.uploadResume);
    api
      .POST(COHORT_ADD_RESOURCES, formData)
      .then((res) => {
        if (res?.data?.success) {
          swal("Resource has been uploaded!", {
            icon: "success",
          }).then((value) => {
            props.parentData(true);
            props.setModalVisibility(false);
          });
        } else {
          swal("Server error,try again later!", {
            icon: "info",
          }).then((value) => {
            props.setModalVisibility(false);
          });
        }
      })
      .catch((err) => {});
  };
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex">
            <Modal.Title className="modalHeading">UPLOAD DOCUMENT</Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />

              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body className="modalBodyFix">
            <div>
              <div className="row inputFieldPadding mobile-coloumnview">
                <div className="col-sm-12 col-md-6 d-flex modalheaduploaddoc">
                  <div className="col-sm-12 col-md-1 iconDiv">
                    <div>1</div>
                  </div>
                  <div className="modalHeadings">DOCUMENT TITLE*</div>
                </div>

                <div className="col-6 doc-ttilt">
                  <input
                    type="email"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Enter Document Title"
                    onChange={(e) => {
                      setDocTitle(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="row inputFieldPadding secondHeading mobile-coloumnview">
                <div className="col-sm-12 col-md-6 d-flex modalheaduploaddoc">
                  <div className="iconDiv">
                    <div>2</div>
                  </div>
                  <div className="modalHeadings">UPLOAD DOCUMENT*</div>
                </div>
                <div className="col-sm-12 col-md-6 doc-ttilt">
                  <div className="newuserTooltip top-btn">
                    <button onClick={clickonFileinput} className="newUploadBtn">
                      CLICK TO UPLOAD
                    </button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{ top: "47px", left: "89px", width: "auto" }}
                    >
                      Upload Document
                    </span>
                  </div>
                  <div className="uploadDocumentModal">
                    <input
                      className="uploadDocumentInput"
                      type="file"
                      id="fileUpload-resume"
                      required
                      name="uploadResume"
                      onChange={handleInputChange}
                      accept="application/pdf,image/png,image/jpeg,image/jpg,"
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="uploadDocDisclaimar">
                    Supported file format png, jpeg, jpg, PDF only upto 10 MB
                  </div>
                  {fileData && fileData?.uploadResume !== null && (
                    <div style={{ marginBottom: "50px" }}>
                      <div className="file-name" style={{ float: "left" }}>
                        {fileData?.uploadResume?.name}{" "}
                        <span
                          style={{ marginLeft: "10px" }}
                          onClick={() => removeFile("uploadResume")}
                        >
                          {" "}
                          X{" "}
                        </span>
                      </div>
                    </div>
                  )}
                  {errorVisible && (
                    <div className="login-error-msg mt-1">
                      Please enter all details*
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="d-flex justify-between feedBackFooterFix">
              <div>
                <Button
                  onClick={handleClose}
                  text="BACK"
                  className="modalButton3 doc-upload"
                ></Button>
              </div>
              <div>
                <Button
                  onClick={handleSubmit}
                  text="SUBMIT"
                  className="modalButton3 doc-uploadnext"
                ></Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    uploadDocumentData: state.StartUpReducer.uploadDocument,
  };
};

export default connect(mapStateToProps, { postUploadDocument })(
  withRouter(ModalDocUpload)
);
